import { useCallback } from 'react';
import { NavigateOptions, useLocation, useNavigate } from 'react-router-dom';
import { getLocaleFromPathname, withLocalePath } from '@/i18n/localeRouting';
import { getCurrentLanguage } from '@/i18n/useTranslation';

export function useAppNavigate() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to: string | number, options?: NavigateOptions) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      const targetPath = to.split('?')[0].split('#')[0];
      if (getLocaleFromPathname(targetPath)) {
        navigate(to, options);
        return;
      }

      const locale = getLocaleFromPathname(location.pathname) ?? getCurrentLanguage();
      navigate(withLocalePath(to, locale), options);
    },
    [location.pathname, navigate]
  );
}
